//TODO : Refactor after ai
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

export interface SidebarProps extends HTMLAttributes<HTMLElement> {
  brand?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  collapsed?: boolean;
  width?: number;
  style?: CSSProperties;
}

/** Seitenleiste der App: Markenzeile, scrollender Körper, fixierter Fuß. */
export function Sidebar({
  brand,
  children,
  footer,
  collapsed,
  width = 264,
  className = "",
  style,
  ...rest
}: SidebarProps) {
  return (
    <aside
      className={className}
      style={{
        width: collapsed ? 72 : width,
        flexShrink: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "var(--bg-primary)",
        boxShadow: "inset -1px 0 0 0 var(--neutral-100)",
        ...style,
      }}
      {...rest}
    >
      {brand && (
        <div
          style={{
            padding: collapsed ? "16px 12px" : "20px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "flex-start",
          }}
        >
          {brand}
        </div>
      )}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "0 12px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {children}
      </div>
      {footer && (
        <div style={{ padding: 12, boxShadow: "inset 0 1px 0 0 var(--neutral-100)" }}>
          {footer}
        </div>
      )}
    </aside>
  );
}
